import { useState } from "react";
import { toast } from "sonner";
import { cld, errMsg } from "@/lib/api";
import { uploadFile } from "@/components/admin/UrlUpload";

const Thumb = ({ img, i, last, move, remove, testid }) => (
  <div className="w-24" data-testid={`${testid}-img-${i}`}>
    <img src={cld(img.url, "w_160,q_auto,f_auto")} alt="" className="aspect-[4/5] w-24 bg-[#F2EEE6] object-cover" />
    <div className="mt-1 flex justify-between text-xs">
      <button type="button" disabled={i === 0} className="disabled:opacity-30" onClick={() => move(i, -1)} data-testid={`${testid}-left-${i}`}>←</button>
      <button type="button" className="text-[#8B2E24]" onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`}>✕</button>
      <button type="button" disabled={last} className="disabled:opacity-30" onClick={() => move(i, 1)} data-testid={`${testid}-right-${i}`}>→</button>
    </div>
  </div>
);

export const VariantImages = ({ images, set, testid }) => {
  const [busy, setBusy] = useState(false);
  const [url, setUrl] = useState("");
  const move = (i, d) => {
    const n = [...images];
    [n[i], n[i + d]] = [n[i + d], n[i]];
    set(n);
  };
  const onFiles = async (e) => {
    const files = [...(e.target.files || [])];
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    const added = [];
    for (const f of files) {
      try {
        added.push({ url: await uploadFile(f, "art-store/mockups"), alt: "" });
      } catch (err) {
        toast.error(errMsg(err, `Upload failed: ${f.name}`));
      }
    }
    set([...images, ...added]);
    setBusy(false);
    if (added.length) toast.success(`${added.length} photo${added.length > 1 ? "s" : ""} added to this size`);
  };
  const addUrl = () => {
    if (!url.trim()) return;
    set([...images, { url: url.trim(), alt: "" }]);
    setUrl("");
  };

  return (
    <div data-testid={testid}>
      <span className="field-label mb-2">Photos for this size — shown when a buyer picks it ({images.length})</span>
      <div className="flex flex-wrap gap-3">
        {images.map((img, i) => (
          <Thumb key={`${img.url}-${i}`} img={img} i={i} last={i === images.length - 1} move={move} remove={(n) => set(images.filter((_, k) => k !== n))} testid={testid} />
        ))}
        <label className="flex aspect-[4/5] w-24 cursor-pointer items-center justify-center border border-dashed border-[#B8B2A6] text-center text-xs">
          {busy ? "Uploading…" : "+ Add photos"}
          <input type="file" accept="image/*" multiple className="hidden" disabled={busy} onChange={onFiles} data-testid={`${testid}-files`} />
        </label>
      </div>
      <div className="mt-2 flex gap-2">
        <input className="admin-input" placeholder="…or paste an image URL" value={url} onChange={(e) => setUrl(e.target.value)} data-testid={`${testid}-url-input`} />
        <button type="button" className="whitespace-nowrap border border-[#1A1A1A] px-3 py-2 text-xs" onClick={addUrl} data-testid={`${testid}-url-add`}>Add</button>
      </div>
    </div>
  );
};
